<template>

<div class="progress-switcher">

  <!-- Text half -->
  <div class="progress-switcher-text-wrapper">

    <div
      v-for="(item, index) in items"
      :key="item.slug"
      v-show="index == currentItemIndex"
      class="flex-1 w-full">

      <div class="flex flex-col h-full">

        <h2 class="flex justify-start items-center text-7xl text-primary">
          0{{ index + 1 }}
        </h2>
        <h3>{{ item.title }}</h3>
        <div v-html="item.content" class="py-6 flex flex-1 flex-col justify-center bard sub-bard"></div>

      </div>

    </div>
    <img src="/svg/arrow-right.svg" alt="Arrow right" class="progress-switcher-arrow" @click="switchToNextItem()">
  </div>

  <!-- Mobile: Vertical spacing -->
  <div class="w-full py-4 lg:hidden"></div>

  <!-- Progress half -->
  <div class="progress-switcher-progress-wrapper">

      <!-- Chart -->
      <canvas id="doughnut-chart" :width="doughnutSize" :height="doughnutSize"></canvas>

      <!-- Icon -->
      <div
        v-for="(item, index) in items"
        :key="item.slug"
        v-show="index == currentItemIndex">
          <div>
            <img v-if="item.icon" :src="item.icon.url" alt="Icon" class="progress-switcher-icon">
          </div>
      </div>

      <!-- Circle overlaying the doughnut chart -->
      <div class="doughnut-circle"></div>

  </div>
</div>

</template>

<script>
  import Chart from 'chart.js';
  import { LoadApiData } from '../modules/api.js';

  export default {
    props: {
      collection: {
        type: String
      }
    },
    data() {
      return {
        items: [],
        currentItemIndex: 0,
        chart: null,
        doughnutSize: 300,
        cutoutPercentage: 88
      }
    },
    methods: {
      init: function(){
        var chartContext = document.getElementById('doughnut-chart');

        this.chart = new Chart(chartContext, {
          type: 'doughnut',
          data: {
            datasets: [{
              data: [0, 100],
              backgroundColor: [
                "#f0951d",
                "rgba(227, 227, 227,1)",
              ],
              borderWidth: 0,
              hoverBackgroundColor: [
                "#f0951d",
                "rgba(227, 227, 227,1)",
              ]
            }
          ]},
          options: {
            responsive: false,
            cutoutPercentage: this.cutoutPercentage,
            maintainAspectRatio : false,
            legend:{
                display: false
            },
            tooltips: {
              enabled: false
            }
          }
        });

        this.updateViews();

        // Frühauf design element: set black circle width/height
        let doughnutCircle = document.getElementsByClassName('doughnut-circle');
        if(doughnutCircle.length > 0){
          let cutoutPercentageHalf = 100 - (100 - this.cutoutPercentage) / 2;
          let radius = this.doughnutSize * (cutoutPercentageHalf / 100);

          doughnutCircle[0].style.width = radius + "px";
          doughnutCircle[0].style.height = radius + "px";
        }
      },
      switchToNextItem: function(){
        if(this.currentItemIndex < this.items.length - 1)
          this.currentItemIndex++;
        else this.currentItemIndex = 0;
      },
      updateViews: function(){
        let percentage = (100 / this.items.length) * (this.currentItemIndex + 1);

        this.chart.data.datasets[0].data = [percentage, 100 - percentage];
        this.chart.update();
      }
    },
    watch: {
      currentItemIndex: function(){
        this.updateViews();
      }
    },
    mounted: function(){
      this.init();
      var context = this;

      const api = '/api/collections/' + this.collection + '/entries';
      const fields = 'slug,title,icon,content';
      const sort = 'index';
      LoadApiData(api, fields, null, sort,function(response){
        context.items = response.data;
        context.updateViews();
      });
    }
  }
</script>
